import { Topic } from '../../../utils/pub-sub/pub-sub';
import { useSubscribe } from '../../../utils/pub-sub/useSubscribe';
import { useCartState } from '../contexts/useCartState';
import type { ProductItem } from '../../../bff-api/baskets/model';

export function useScrollToPrevious(headerHeight: number): void {
    const { itemRefs, cartProductItemsOrder } = useCartState();
    useSubscribe<Pick<ProductItem, 'productId' | 'itemId'>>(
        Topic.PRODUCT_ITEM_DELETED,
        ({ itemId }) => {
            const idx = cartProductItemsOrder.findIndex((cpio) => cpio.itemId === itemId);

            if (idx - 1 > -1) {
                const previousProductId = cartProductItemsOrder[idx - 1].productId;
                const previousElement = itemRefs.current?.get(previousProductId);

                const topOfPreviousElement =
                    (previousElement?.getBoundingClientRect().top ?? 0) +
                    window.scrollY -
                    headerHeight;

                window.scrollTo({ top: topOfPreviousElement, behavior: 'smooth' });
                return;
            }

            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        [headerHeight, cartProductItemsOrder],
    );
}
